import './index.less'
function pushMessage(content, type) {
    if(!customElements.get("toast-message-manager") || !customElements.get("toast-message")) {
        const initToast = (content, type) => import('./jky-toast').then((module) => {
            const toast = module.default;
            toast();
            setTimeout(() => {
                document.querySelector('toast-message-manager').pushMessage(content, type);
            }, 16);
            return true;
          }).catch(() => false);

          initToast(content, type);
    } else {
        document.querySelector('toast-message-manager').pushMessage(content, type);
    }
}

function pushSuccessMessage(content) {
    pushMessage(content, 'success');
}

function pushErrorMessage(content) {
    pushMessage(content, 'error');
}

export {
    pushMessage,
    pushSuccessMessage,
    pushErrorMessage
}